var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuroPersonaF(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 69,
    viewBox: "0 0 66 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "p_fisica"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_320_294)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M55.762 67.2617C48.9637 56.4843 47.6688 49.7766 28.751 49.7766C9.83312 49.7766 8.51801 56.4843 1.71973 67.2617",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.731 40.0216C39.1903 40.0216 47.6691 31.4516 47.6691 20.88C47.6691 10.3083 39.1903 1.7383 28.731 1.7383C18.2718 1.7383 9.79297 10.3083 9.79297 20.88C9.79297 31.4516 18.2718 40.0216 28.731 40.0216Z",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M52.2012 42.7007H64.9884",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M58.5947 36.2383V49.1835",
    stroke: "#1FDD8F",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_320_294"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66,
    height: 69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuroPersonaF);
export default __webpack_public_path__ + "static/media/buroPersonaF.2b70f6e6f4fd341df96c3e37a295bf56.svg";
export { ForwardRef as ReactComponent };